import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import './Dashboard.scss';
import '../Uptime/Uptime.css';

export default function Dashboard() {
  return (
    <>
      <Helmet>
        <title>Dashboard | Titan Secure</title>
        <meta name="description" content="Titan Secure system dashboard" />
      </Helmet>
      <div className="dashboard-container">
        <h1>System Dashboard</h1>
        <div className="dashboard__content">
          <Outlet />
        </div>
      </div>
    </>
  );
} 